import { format as p } from "../util.mjs";
var r = function(t, a, i, e, n) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(a) || e.push(p(n.messages.pattern.mismatch, t.fullField, a, t.pattern));
    else if (typeof t.pattern == "string") {
      var s = new RegExp(t.pattern);
      s.test(a) || e.push(p(n.messages.pattern.mismatch, t.fullField, a, t.pattern));
    }
  }
};
export {
  r as default
};
//# sourceMappingURL=pattern.mjs.map
